export default __webpack_public_path__ + "static/media/Diamondbacks.fa355a32.png";